import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthButton } from '@/components/ui/AuthButton';
import { Button } from '@/components/ui/button';

export function CTAFinale(): React.ReactElement {
  const navigate = useNavigate();

  function handleSeePricing(): void {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <section className="py-24 md:py-32 px-6 relative overflow-hidden bg-bottle-green text-white">
      {/* Watercolor gradient overlay */}
      <div className="absolute inset-0 watercolor-gradient-alt opacity-40" aria-hidden="true" />

      {/* Decorative border */}
      <div className="absolute inset-4 border border-white/10 rounded-2xl pointer-events-none" aria-hidden="true" />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="font-display font-bold tracking-tight leading-[1.1] mb-8 text-white text-[clamp(2.25rem,4.5vw+0.5rem,3.75rem)]">
          Stop working nights.<br />
          Start publishing proudly.
        </h2>
        <p className="font-body text-xl md:text-2xl text-white/90 mb-12 max-w-2xl mx-auto leading-relaxed">
          Get 8-12 hours back every week without sacrificing quality.
        </p>

        <p className="mb-12 text-base md:text-lg text-white/85 max-w-2xl mx-auto">
          First article free{' '}
          <span className="text-white/40 mx-3" aria-hidden="true">&middot;</span>{' '}
          No setup required{' '}
          <span className="text-white/40 mx-3" aria-hidden="true">&middot;</span>{' '}
          Results in 90 minutes
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <AuthButton
            size="lg"
            variant="terracotta"
            className="w-full sm:w-auto text-lg h-16 px-12 bg-white text-bottle-green hover:bg-champagne rounded-lg shadow-xl"
            onAuthenticatedClick={() => navigate('/research/deep')}
          >
            Start Free Trial Now
          </AuthButton>
          <Button
            variant="outline"
            size="lg"
            className="w-full sm:w-auto h-16 px-12 text-lg border-white/30 text-white bg-transparent hover:bg-white hover:text-bottle-green rounded-lg transition-colors"
            onClick={handleSeePricing}
          >
            See Pricing & Packages
          </Button>
        </div>
      </div>
    </section>
  );
}
